import React from 'react';
import clsx from 'clsx';
import { styled } from '@components-shared/src/stitches';
import { VerifiedRainbow } from '@components/icons/VerifiedRainbow';
import { Tooltip } from './Tooltip';

export const VerifiedTooltip = ({
  toolTipOffset,
  portal = false,
  noTooltip = false,
  size = 20,
}: {
  toolTipOffset?: number;
  /** If true, the tooltip will be rendered in a portal */
  portal?: boolean;
  noTooltip?: boolean;
  size?: number;
}) => {
  const verifiedCheck = (
    <VerifiedContainer
      className={clsx(
        !noTooltip && 'md:[&_svg]:hover:rounded-full md:[&_svg]:hover:shadow-secondary ',
      )}
      css={{
        svg: {
          height: size ? `${size}px` : '20px',
          width: size ? `${size}px` : '20px',
        },
      }}
    >
      <VerifiedRainbow />
    </VerifiedContainer>
  );

  const content = (
    <Tooltip.StyledContent className="px-2" sideOffset={toolTipOffset}>
      Verified Artist
    </Tooltip.StyledContent>
  );
  return noTooltip ? (
    <div>{verifiedCheck}</div>
  ) : (
    <div>
      <div className="block md:!hidden">{verifiedCheck}</div>
      <div className="!hidden md:!block">
        <Tooltip openOnClick={false}>
          <Tooltip.Trigger asChild>{verifiedCheck}</Tooltip.Trigger>
          {portal ? <Tooltip.Portal>{content}</Tooltip.Portal> : content}
        </Tooltip>
      </div>
    </div>
  );
};

const VerifiedContainer = styled('div', {});
